const circularQueue = function (maxSize) {
  let buffer = new Array(maxSize);
  let head = 0;
  let tail = 0;
  let size = 0;

  return Object.freeze({
    get: (key) => {
      if (key < 0) {
        return buffer[tail + key];
      } else if (key === false) {
        return buffer[tail - 1];
      } else {
        return buffer[key];
      }
    },

    array: () => {
      let index = head;
      let data = [];
      for (let i = 0; i < size; i++) {
        data.push(buffer[index]);
        index = (index + 1) % maxSize;
      }
      return data;
    },

    push: (element) => {
      buffer[tail] = element;
      tail = (tail + 1) % maxSize;
      if (size < maxSize) ++size;
      else head = tail;
      return element;
    },

    pop: () => {
      if (size == 0) return null;
      --size;
      let element = buffer[head];
      head = (head + 1) % maxSize;
      return element;
    },

    size: () => {
      return size;
    },

    clear: () => {
      tail = head;
      size = 0;
    },

    empty: () => {
      return size === 0;
    },

    full: () => {
      return size === maxSize;
    },
  });
};

export { circularQueue };
